import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';


const ModalCampaignType = ({ show, handleModalhide, handlerCampaignType }) => {
    const [isLoading, setIsLoading] = useState(false);


    return (
        <>
            <Modal
                show={show}
                onHide={handleModalhide}
                size="lg"
                centered
                contentClassName="campaign-card border-0"
                style={{ backgroundColor: 'transparent' }}
            >
                <Modal.Header closeButton className="border-0 pb-0" style={{ background: '#0f172a', border: 'none' }}>
                    <Modal.Title className="campaigns-section-title fs-3 mb-0">🚀 Tipo de Campanha</Modal.Title>
                </Modal.Header>

                <Modal.Body className="py-4" style={{ background: '#0f172a', border: 'none' }}>
                    <p className="text-muted mb-4 px-2">Escolha o canal de comunicação mais eficaz para o seu objetivo.</p>

                    <div className="row g-3">
                        {/* Notificações */}
                        <div className="col-12 col-md-4">
                            <div
                                className="instruction-box rounded-4 p-4 h-100 d-flex flex-column align-items-center text-center cursor-pointer"
                                onClick={() => handlerCampaignType('notification')}
                                style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
                            >
                                <div className="mb-3 d-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded-circle" style={{ width: '60px', height: '60px' }}>
                                    <i className="fa-regular fa-bell fs-2 text-primary"></i>
                                </div>
                                <h4 className="text-white fs-5 mb-2">Notificações</h4>
                                <p className="text-muted small mb-3">Push direto para a App Nightspot. Grátis e eficaz.</p>
                                <button className="btn-action btn-campaign-secondary py-2 px-4 mt-auto rounded-pill border-0 w-auto">
                                    Escolher
                                </button>
                            </div>
                        </div>

                        {/* SMS */}
                        <div className="col-12 col-md-4">
                            <div
                                className="instruction-box rounded-4 p-4 h-100 d-flex flex-column align-items-center text-center cursor-pointer"
                                onClick={() => handlerCampaignType('sms')}
                                style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
                            >
                                <div className="mb-3 d-flex align-items-center justify-content-center bg-info bg-opacity-10 rounded-circle" style={{ width: '60px', height: '60px' }}>
                                    <i className="fa-solid fa-comment-sms fs-2 text-info"></i>
                                </div>
                                <h4 className="text-white fs-5 mb-2">SMS</h4>
                                <p className="text-muted small mb-3">Alcance telemóveis sem internet com taxa de abertura de 90%.</p>
                                <button className="btn-action btn-campaign-secondary py-2 px-4 mt-auto rounded-pill border-0 w-auto">
                                    Escolher
                                </button>
                            </div>
                        </div>

                        {/* WhatsApp */}
                        <div className="col-12 col-md-4">
                            <div
                                className="instruction-box rounded-4 p-4 h-100 d-flex flex-column align-items-center text-center cursor-pointer"
                                onClick={() => handlerCampaignType('whatsapp')}
                                style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
                            >
                                <div className="mb-3 d-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle" style={{ width: '60px', height: '60px' }}>
                                    <i className="fa-brands fa-whatsapp fs-2 text-success"></i>
                                </div>
                                <h4 className="text-white fs-5 mb-2">WhatsApp</h4>
                                <p className="text-muted small mb-3">Comunicação rica e visual na rede mais usada em Portugal.</p>
                                <button className="btn-action btn-campaign-secondary py-2 px-4 mt-auto rounded-pill border-0 w-auto" style={{ border: '1px solid #25D366 !important', color: '#25D366 !important' }}>
                                    Escolher
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>


        </>
    )
}


export default ModalCampaignType